import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from '../model/track-action-result';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';
import { trackDefaultIncomeBasic } from '../cadastro-investidor/util/track-default-income';
import { OriginInvestActionV2 } from '../cadastro-investidor-v2/actions/origin-v2-action';
import { OriginIncomeInvestActionV2 } from '../cadastro-investidor-v2/actions/origin-income-v2-action';
import { CompanyActionV2 } from '../cadastro-investidor-v2/actions/company-v2-action';
import { trackIncomeUpdateContaIon } from '../cadastro-investidor-v2/util/track-default-income-v2';

export class UpdateProfessionalTrack extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('origin-income', ['professional-data', 'origin-income'], undefined, {
      undefined,
      actionName: ActionList.ActionOrigin
    }),
    new TrackInfo('profession', ['professional-data', 'profession'], undefined, {
      undefined,
      actionName: ActionList.ActionIncome
    }),
    new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj'], undefined, {
      undefined,
      actionName: ActionList.actionCompany
    })
  ];
  
  readonly finalPagesTrack = [
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.updateRegistration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, { dataOrigin: DomainOrigin[environment.updateRegistration] })
  ]

  track = [];

  constructor() {
    super();
    this.track = [
      ...this.originalTracks,
      ...trackDefaultIncomeBasic,
      ...this.finalPagesTrack
    ];
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.UPDATE_REGISTRATION;
  }

  async loadData() {
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    switch (actionName) {
      case ActionList.ActionOrigin:
        return OriginInvestActionV2.execute(data, this.track, true, this.inclueTrackPagesNif.bind(this));
      case ActionList.ActionIncome:
        return OriginIncomeInvestActionV2.execute(data);
      case ActionList.actionCompany:
        return CompanyActionV2.execute(data);
    }
  }

  isUncoupled() {
    return true;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }

  inclueTrackPagesNif() {
    this.track = [
      ...this.originalTracks,
      ...trackIncomeUpdateContaIon,
      ...this.finalPagesTrack
    ];
  }
}

export enum ActionList {
  ActionOrigin = 'actionOrigin',
  ActionIncome = 'actionIncome',
  actionCompany = 'actionCompany'
}
